module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type === 'inline') ? _c('div', {
    staticClass: "inline"
  }, [_c('transition-group', {
    attrs: {
      "name": "blur",
      "tag": "div"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentSrc === null),
      expression: "currentSrc === null"
    }],
    key: "placeholder",
    staticClass: "placeholder blur-transition"
  }), _vm._v(" "), _c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentSrc === _vm.lowResSrc),
      expression: "currentSrc === lowResSrc"
    }],
    key: "canvas",
    staticClass: "blur-transition",
    attrs: {
      "height": "17",
      "width": "27"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentSrc === _vm.hiResSrc),
      expression: "currentSrc === hiResSrc"
    }],
    key: "image",
    staticClass: "blur-transition",
    attrs: {
      "src": _vm.hiResSrc
    }
  })])], 1) : _c('div', {
    staticClass: "backgroundImage",
    style: (_vm.styleObject)
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2f23869a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f23869a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlurryImage.vue
// module id = 769
// module chunks = 3